import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'

@Component({})
export default class BaseCard extends Vue {
  @Prop(String) title!: string
  @Prop(Boolean) noHeader!: boolean
  @Prop(Boolean) noFooter!: boolean
}
